<script setup>
import { reactive, computed, ref, watch, onMounted } from 'vue'
import appAxios from '@/libs/app-axios'
import { useStore } from '@/store'
import Form from './Form.vue'
import Index from './Index.vue'

const store = useStore()
const attendanceSheetIndexRef = ref(null)

const accessLevel = computed(() => store.state.auth?.accessLevel)

</script>

<template>
  <div class="flex flex-column" style="gap:20px;">

    <Form />

    <Index ref="attendanceSheetIndexRef" />
  </div>
</template>

<script>
export default {
  name: 'AttendanceSheetPage',
}
</script>
